import { Filter } from '@src/pages/[...slug]/components/collection/domains/CollectionFilter'
import { PRODUCT_FILTER_KEYS } from '@src/quince-site-common/src/constants/product'

const DEPARTMENT_EXCLUDE_SLUG_LIST = [
  '/men',
  '/women',
  '/women/new-arrivals',
  '/men/new-arrivals',
  '/women/best-sellers',
  '/men/best-sellers',
  '/all/new-arrivals',
]

export function excludeDepartmentFilter(filters: Filter[], slug: string | undefined) {
  if (!slug) return filters
  return DEPARTMENT_EXCLUDE_SLUG_LIST.includes(slug)
    ? filters.filter(filter => filter.name !== (PRODUCT_FILTER_KEYS.departments as string))
    : filters
}
